import { Checkbox, Container, Grid, makeStyles, AppBar, Tabs, Tab, Box, FormGroup, FormControlLabel } from '@material-ui/core';
import React, { useContext, useEffect, useState } from 'react'
import logo from '../assets/logo (2).png'
import PlayerCard from './PlayerCard';

import { useState as useHook, State, none } from '@hookstate/core';

import defaultUser from '../utils/DefaultUserData'

import websocket from '../utils/WebsocketConnection'
import timeManager from '../utils/TimeManager'
import DiceWebsocket from './DiceWebsocket';
import storageManager from '../utils/LocalStorageManager'
import DiceHistory from './DiceHistory';
import Dices from './Dices';

// import { usePlayers } from './usePlayers';

const useStyles = makeStyles((theme) => ({
  root: {

  },
  background: {
    backgroundImage: 'linear-gradient(to right bottom, #2e2e2e, #2c2c2c, #2a2a2a, #292929, #272727, #282829, #29282c, #2b292e, #312c34, #382e39, #40313e, #483341)',
    minHeight: '100vh'
  },
  logo: {
    display: 'flex',
    width: '500px',
    justifyContent: 'center',
    margin: 'auto',
    marginBottom: '10px'
  },
  gridList: {
    flexWrap: 'nowrap',
    // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
    transform: 'translateZ(0)',
    overflow: 'auto',
    transform: 'rotateX(180deg)',
    // scrollbarXPosition: 'top'
  },
  connect: {
    paddingLeft: 'auto',
    paddingRight: 'auto'
  }
}));

export default function Master() {
  const classes = useStyles();

  const games = useHook({})
  const [connected, setConnected] = useState(false)
  const [value, setValue] = useState(0);
  const [diceHistory, setDiceHistory] = useState([]);

  const connect = () => {
    const roomName = window.prompt('Sala: ', 'rpgkaiju')
    storageManager.setRoom(roomName)

    websocket.subscribeChannel(storageManager.getRoom(), 'ficha', (data) => updateGame(data))

    setConnected(true)
  }

  const disconnect = () => {
    storageManager.setRoom(null)

    websocket.disconnect()

    setConnected(false)
  }

  const handleChange = () => {
    if (connected) {
      disconnect()
      setConnected(false)
    }
    else {
      connect()
      setConnected(true)
    }
  }

  const updateGame = (data) => {
    games[data.id].set(data)
  }
  const deletePlayer = (id) => {
    games[id].set(none)
  }

  const handleChangeTab = (event, newValue) => {
    setValue(newValue);
  };

  const diceRolled = (data) => {
    data.time = timeManager.getNowTime();
    setDiceHistory(oldState => [...oldState, data])
  }

  return (
    <div className={classes.background}>
      <img className={classes.logo} src={logo} alt="logo" />
      {/* <Checkbox
        checked={connected}
        onChange={() => handleChange()}
        inputProps={{ 'aria-label': 'primary checkbox' }}
      />Connect */}

      <Grid container justify="center">
        <FormControlLabel
          control={
            <Checkbox
              checked={connected}
              onChange={() => handleChange()}
              inputProps={{ 'aria-label': 'primary checkbox' }}
            />
          }
          label="Connect"
        />
      </Grid>


      <AppBar position="static">
        <Tabs value={value} onChange={handleChangeTab} aria-label="simple tabs example">
          <Tab label="Fichas" />
          <Tab label="Historico de dados" />
          <Tab label="Dados" />
        </Tabs>
      </AppBar>

      <TabPanel value={value} index={0}>
        <Box className={classes.gridWrapper}>
          <Grid container spacing={4} className={classes.gridList}>

            {Object.values(games.get()).map((player) => (
              <PlayerCard key={player.id} player={player} deleteComponent={(id) => deletePlayer(id)} />
            ))}
            {/* {Object.values(games.get()).map((player) => (
              <PlayerCard key={player.id} player={player} deleteComponent={(id) => deletePlayer(id)} />
            ))} */}
            {/* {Object.values(games.get()).map((player) => (
              <PlayerCard key={player.id} player={player} deleteComponent={(id) => deletePlayer(id)} />
            ))}
            {Object.values(games.get()).map((player) => (
              <PlayerCard key={player.id} player={player} deleteComponent={(id) => deletePlayer(id)} />
            ))}
            {Object.values(games.get()).map((player) => (
              <PlayerCard key={player.id} player={player} deleteComponent={(id) => deletePlayer(id)} />
            ))}
            {Object.values(games.get()).map((player) => (
              <PlayerCard key={player.id} player={player} deleteComponent={(id) => deletePlayer(id)} />
            ))}
            {Object.values(games.get()).map((player) => (
              <PlayerCard key={player.id} player={player} deleteComponent={(id) => deletePlayer(id)} />
            ))}
            {Object.values(games.get()).map((player) => (
              <PlayerCard key={player.id} player={player} deleteComponent={(id) => deletePlayer(id)} />
            ))} */}

          </Grid>
        </Box>
      </TabPanel>

      <TabPanel value={value} index={1}>
        <DiceHistory diceHistory={diceHistory} />
      </TabPanel>

      <TabPanel value={value} index={2}>
        <Dices />
      </TabPanel>

      <DiceWebsocket connected={connected} diceRolled={diceRolled} />
    </div>
  )
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          {children}
        </Box>
      )}
    </div>
  );
}
